import styled from 'styled-components'
import {space, textAlign} from 'styled-system'
import typography from 'lib/style/typography'

const H2 = styled.h2`
  margin: 0;
  ${space};
  ${textAlign};
  ${typography};
  font-size: 1.125rem;
  font-weight: 300;
`

export default H2
